<div class="dashboard-wrapper">
  <!-- Spinner de Carregamento -->
  <div *ngIf="loading" class="loading-box">
    <p>🔄 A carregar Dashboard seguro do Power BI...</p>
  </div>

  <!-- Mensagem de Erro -->
  <div *ngIf="errorMsg" class="error-box">
    <p>⚠️ {{ errorMsg }}</p>
  </div>

  <!-- Container de Renderização do Power BI -->
  <div #powerbiContainer class="powerbi-container" [hidden]="loading || errorMsg"></div>
</div>